<template>
  <div v-loading.fullscreen="listLoading"
       class="container container-box">
    <div class="list-header">
      <div class="header-line"></div>
      <div class="header-title">{{$t('my.nav.collection')}}</div>
    </div>
    <div style="background: #fff;">
      <NoData v-if="list.length <=0"
              v-bind:title="$t('collection.nodata')"></NoData>
    </div>
    <el-row class='favorite-list'>
      <el-col :span="8" v-for="(o, index) in list"
              :key="index">
        <el-card :body-style="{ padding: '0px' }">
            <FavoriteItem
                @refDelItem="canleFan"
                v-bind:isChinese="isChinese"
                v-bind:o="o"></FavoriteItem>
        </el-card>
      </el-col>
    </el-row>
    <div v-infinite-scroll="loadMore"
         infinite-scroll-disabled="busy"
         infinite-scroll-distance="10"></div>
  </div>
</template>
<style scoped>
  @import "../css/list-item.scss";

  .favorite-list{
    min-height:625px;
  }
  .el-card{
    margin-right: 10px;
    margin-bottom: 10px;
    height: 280px;
    box-sizing: border-box;
  }
  >>>.el-card__body {
    height: 100%;
    position: relative;
    border-radius: 3px;
    /*overflow: hidden;*/
  }
  .favorite-list{
    margin-right: 0px;
    padding-top:10px;
    padding-left:20px;
    padding-right:10px;
    background: #fff;
    box-sizing: border-box;
  }
  @media (max-width: 1200px){
    /*.web-link > span {*/
      /*display: none;*/
    /*}*/
    .web-link >img{
      display: none;
    }
  }
  @media (max-width:650px){
    .favorite-list  .el-col-8{
      width: 100%;
    }
  }

  .el-card{
    overflow: inherit;
  }


</style>
<script>
import { getFavorite } from '@/api/user'
import { formatTime,whatLang } from '@/utils/index'
import jump from 'jump.js'
import NoData from '../components/NoData'
import FavoriteItem from '../components/FavoriteItem'
export default {
  components:{NoData,FavoriteItem},
  data() {
    return {
      list: [],
      listLoading: true,
      page:1,
      page_size: 9,
      busy: true,
      currentDate: new Date(),
      user:{},
      isChinese: whatLang() !='zh'
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(flag) {
      this.listLoading = true;
      getFavorite({
        page: this.page,
        page_size: this.page_size
      }).then(response => {
        this.listLoading = false
        var list = response.articles;
        for (let i = 0, l = list.length; i < l; i++) {
          list[i].created_at = formatTime(list[i].created_at)
          list[i].site = new URL(list[i].link).host
        }
        if (flag) {
          this.list = this.list.concat(list)
          jump(500, {
            duration: 400
          })
          if (list.length == 0) {
            this.busy = true;
          } else{
            this.busy = false;
          }
        } else {
          // 首次加载数据
          this.list = list || [];
          this.busy = false;
        }
      })
    },
    loadMore() {
      this.busy = true;
      this.page ++;
      this.fetchData(true);
    },
    toRead(o) {
      this.$router.push({ path: '/read/'+o.id })
    },
    canleFan(e){
      for (let i = 0; i < this.list.length; i++) {
        if(this.list[i].id == e.id){
            console.log('ok');

            if(!e.isCollection){
              let list_arr = this.list;
              list_arr.splice(i,1);
              this.list = list_arr;
            }else{
               this.list[i].isCollection = true;
            }
            break;
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/favorites.vue